// extracted by mini-css-extract-plugin
export default {"textMessage__time":"TextMessage_textMessage__time__Ls2cU","textMessage_outgoing__fileSize":"TextMessage_textMessage_outgoing__fileSize__nKwu1"};